import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../i18n/locales/en/translation.json';
import fr from '../i18n/locales/fr/translation.json';
import ar from '../i18n/locales/ar/translation.json';

const LANGUAGE_STORAGE_KEY = 'cicada.language';
const SUPPORTED_LANGUAGES = ['fr', 'en', 'ar'];
const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
const initialLanguage = SUPPORTED_LANGUAGES.includes(savedLanguage) ? savedLanguage : 'fr';

const applyDocumentLanguage = (language) => {
    const isRTL = language === 'ar';
    document.documentElement.setAttribute('lang', language);
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    document.body.classList.toggle('rtl-layout', isRTL);
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            fr: { translation: fr },
            en: { translation: en },
            ar: { translation: ar }
        },
        lng: initialLanguage,
        fallbackLng: 'fr',
        interpolation: {
            escapeValue: false
        }
    });

// Keep the document direction in sync wherever the language is changed
// (login page, header, password-reset pages, etc.).
i18n.on('languageChanged', (language) => {
    if (SUPPORTED_LANGUAGES.includes(language)) {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
    applyDocumentLanguage(language);
});
applyDocumentLanguage(i18n.language);

export default i18n;
